// extracted by mini-css-extract-plugin
export default {"noselect":"main_noselect__FLdL2","reselect":"main_reselect__4CK9Z","nodrag":"main_nodrag__Xe6vo"};